import apiClient from "../clients/apiClient";
import { safeRequest } from "../safeRequest";

export const MatchesService = {
  async updateResult(matchId, { team1Score, team2Score }) {
    return safeRequest(
      apiClient
        .patch(`/matches/${matchId}/result`, { team1Score, team2Score })
        .then((response) => response.data),
    );
  },

  async cancel(matchId) {
    return safeRequest(
      apiClient
        .patch(`/matches/${matchId}/cancel`)
        .then((response) => response.data),
    );
  },

  async substituteWithCoringa(matchId, payload) {
    return safeRequest(
      apiClient
        .patch(`/matches/${matchId}/substitute-with-coringa`, payload)
        .then((response) => response.data),
    );
  },
};
